<form class="search-form d-flex align-items-center" (ngSubmit)="onSearch()">
  <mat-icon>search</mat-icon>
  <mat-form-field class="search-field" appearance="outline">
    <input matInput class="search-input" type="text" placeholder="Search" [formControl]="searchControl" (keydown.enter)="onSearch()" />
  </mat-form-field>
  <button mat-flat-button type="button" class="search-btn" (click)="onSearch()">Search</button>
</form>
